
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Créer un site Internet de psychologue – Exemples, Prix et Délais",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Un site Internet professionnel de qualité se présente comme un excellent relais de croissance pour votre activité de psychologue. Cet article vous explique tout !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Créer un site Internet de psychologue – Exemples, Prix et Délais",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Un site Internet professionnel de qualité se présente comme un excellent relais de croissance pour votre activité de psychologue. Cet article vous explique tout !",
        },
      ],
    };
  },
};
